import React, { useState, useEffect } from "react";
import axios from "axios";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Autosuggest from "react-autosuggest";
import { useParams } from "react-router-dom";
import moment from "moment";

export default function Dlmodule() {
    const { http, user } = AuthUser();
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const handleDelete = async () => {
        if (window.confirm("Are you sure you want to delete this item?")) {
            try {
                await http.post('/del_task_comp', {
                    start_date: startDate,
                    end_date: endDate
                });
                toast.success("Item deleted successfully!");
            } catch (error) {
                console.error("Error deleting item", error);
                toast.error("Failed to delete item.");
            }
        }
    };

    const handleExport = async () => {
        try {
            const response = await http.post('/export_task', {
                start_date: startDate,
                end_date: endDate
            });
            // Handle the response for export, e.g., download the file
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'exported_tasks.csv'); // or the appropriate file name
            document.body.appendChild(link);
            link.click();
            toast.success("Tasks exported successfully!");
        } catch (error) {
            console.error("Error exporting tasks", error);
            toast.error("Failed to export tasks.");
        }
    };

    return (
        <>
            <div className="d-flex justify-content-center">
                <div className="col-md-6 col-sm-12">
                    <div className="alert alert-warning mt-3" role="alert">
                        Please check carefully before performing any actions.
                    </div>
                    <div className="receipt-main">
                        <div className="form-group mt-3">
                            <label>Start Date</label>
                            <input
                                type="date"
                                className="form-control"
                                value={startDate}
                                required
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </div>
                        <div className="form-group mt-3">
                            <label>End Date</label>
                            <input
                                type="date"
                                className="form-control"
                                value={endDate}
                                required
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </div>
                        <div className="d-flex justify-content-between">
                            <button
                                className="btn btn-primary mt-3"
                                onClick={handleExport}
                            >
                                Export
                            </button>


                            <button
                                className="btn btn-danger mt-3"
                                onClick={handleDelete}
                            >
                                Delete
                            </button>

                        </div>
                    </div>
                </div>
            </div>
            <Toaster />
        </>
    );
}
